class BSModal {
    constructor(data) {
        this.data = data[0] ? data[0] : data,
        this.extract = data[0] ? true : false,  // bool - true is js object passed, false is dom passed and needs to be extracted
        this.targets = false,
        this.header = false,
        this.content = false,
		this.buttons = false,
        this.size = 'modal-md',
        this.created_modal = '',
        this.confirmCloseModal = false,
        this.onBuildCb = false,
        this.add_togglable_modal = false,

        // Debugging --------------------
        this.debug = { // comment section back in as needed // debug by section
            // init: true,
            // targets: true,
            // header: true,
            // content: true,
            // buttons: true, 
            // etc: true,
            // conf_modal: true,
            // after_dataset_build: true,
            // modal_created: true
            // init_modal: true,
            // onBuild: true
            // add_togglable_modal: true
        }; 
        if(this.debug.init){
            console.log(data, "data");
            console.log(this, "this");
        }
    }

    build_dataset(){
        try{            
            this.modalTargets();
            this.modalHeader();
            this.modalContent();
            this.modalButtons();
            this.modalEtc();
            this.confirmModal();
            this.onBuild();
            this.addModal();
        }catch(e){
            console.log(e);
        }
    }

    create_modal(){
        this.build_dataset();
        if(this.debug.after_dataset_build)
            console.log(this, "this - post build_dataset");

        try{
            var body = this.content.tpl_file && this.content.tpl_file.length > 0 ? '' : this.content.main;
            var btns = this.build_footer();
            var conf_modal = !this.confirmCloseModal ? '' : this.build_confirm_modal();

            this.created_modal = `
                <div class="modal fade ${this.targets.custom_classes.sections.bs_modal_overlay_class}" id="${this.targets.modalid}"  tabindex="-1" role="dialog" aria-hidden="${this.etc.hidden}" >
                    <div class="modal-dialog modal-dialog-centered ${this.targets.custom_classes.sections.bs_dialog_container_class} ${this.etc.size}" role="document">
                        <div class="modal-content ${this.targets.custom_classes.sections.bs_content_container_class}">
                            <div id="${this.targets.modalid}-header" class="modal-header ${this.targets.custom_classes.sections.bs_content_header_class}">
                                <h1 class="modal-title ${this.targets.custom_classes.sections.bs_content_title_class}">
                                    ${this.header.title}
                                    ${this.header.navigation.custom_html}
                                </h1>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">
                                        <i class="fas ${this.header.custom_close_icon && this.header.custom_close_icon.length > 0 ? this.header.custom_close_icon : 'fa-times'}" > </i>
                                    </span>
                                </button>
                            </div>
                            <div id="${this.targets.modalid}-body" class="modal-body ${this.targets.custom_classes.sections.bs_content_body_class}">
                                ${body}
                            </div>
            
                            ${btns}
                        </div>
                    </div>
                </div>
                ${conf_modal}
                `;
    
            if(this.debug.modal_created)
                console.log(this.created_modal, "this.created_modal");

            this.init_bs_modal();
        }catch(e){
            console.log(e);
        }
    }

    init_bs_modal(){
        try{
            if(this.debug.init_modal)
                console.log(this, "this - init_modal");

            const $modalWrapper = am.$('#bs-modal-wrapper');
    
            // check if existsing modal exists
            var existing_modal = $modalWrapper.children();

            if(existing_modal.length > 0){
                // if so hide then remove before build of new modal. Even if same modal is called again so new data will be populated if 
                if(!this.add_togglable_modal && existing_modal.length > 0){
                    existing_modal.hide().remove();
                }
            }
    
            // check use of file
            var file = this.content.tpl_file && this.content.tpl_file.length > 0 ? this.content.tpl_file : false;
    
            var id = this.targets.modalid;

            // append modal to dom and sef ref targ ID
            $modalWrapper
                .append(this.created_modal)
                .attr('data-bs-modal-targetid', id);

            const myModalEl = document.getElementById(id);
    
            // Check for tpl file use in modal-body
            if (file && file.length > 0) {
                const $loading = am.$('#loading');
                myModalEl.addEventListener('show.bs.modal', (e) => {
                    var $modal_content = am.$('.modal-content');
                    show_loading_svg();
                    if($modal_content.length > 0)
                        $modal_content.hide();

                    am.$('#' + id + '-body').load(file, function (response, status, xhr) {
                        if (xhr.status == 200) {
                        } else {
                            show_snackbar({
                                message: get_language_translation('LANG_SOMETHING_WENT_WRONG_PLZ_TRY_AGAIN'),
                                type: 'danger'
                            });
                        }

                        if($modal_content.length > 0)
                            $modal_content.show();
        
                        $loading.hide();
                    });
                });
            }

            var modal = bootstrap.Modal.getOrCreateInstance(myModalEl);
            modal.show();

            if(this.etc.closeOnSuccess){ // modal will only close when modal.hide() is used
                modal._config.backdrop = 'static';
                modal._config.keyboard = false;
            }

            if(this.confirmCloseModal){
                try{
                    myModalEl.onclick = () => { 
                        var conf_modal = new bootstrap.Modal(document.getElementById(this.confirmCloseModal.id));
                        conf_modal._config.backdrop = 'static';
                        conf_modal._config.keyboard = false;

                        modal.hide();
                        conf_modal.show();
                    };
                }catch(e){
                    console.log(e);
                }
            }
        
            if(!this.confirmCloseModal){
                myModalEl.addEventListener('hidden.bs.modal', (e) => {
                    if(e.target.id == 'goToModal')
                        am.$('body').css('overflow', 'auto'); // required to offset overflow being unset on modal close causing page to scroll to top away from desired position
        
                    const mod = document.getElementById(e.target.id);
                    mod.remove();
                })
            }

            if(this.onBuildCb){
                myModalEl.addEventListener('shown.bs.modal', (e) => {
                    this.onBuildCb();
                })
            }

            if(this.add_togglable_modal){
                myModalEl.addEventListener('hide.bs.modal', (e) => {
                    existing_modal.addClass('show');
                })
            }
        }catch(e){
            console.log(e);
        }
    }

    modalTargets(){
        try{
            if(this.extract){
                var dataset = this.data.target.dataset;

                var modalTargets = {
                    modalid: check_data_val(dataset.modalid, 'modalTargets.id'),
                    custom_classes: {
                        sections: {
                            bs_modal_overlay_class: check_data_val(dataset.bsModalOverlayClass), 
                            bs_dialog_container_class: check_data_val(dataset.bsDialogContainerClass), 
                            bs_content_container_class: check_data_val(dataset.bsContentContainerClass), 
                            bs_content_header_class: check_data_val(dataset.bsContentHeaderClass), 
                            bs_content_title_class: check_data_val(dataset.bsContentTitleClass), 
                            bs_content_body_class: check_data_val(dataset.bsContentBodyClass), 
                            bs_content_footer_class: check_data_val(dataset.bsContentFooterClass)
                        }
                    }
                }
            }else{
                var modalTargets = {
                    modalid: check_data_val(this.data.targets.modalid, 'modalTargets.id'), 
                    custom_classes: { 
                        sections: !this.data.targets.custom_classes || !this.data.targets.custom_classes.sections ? {
                            bs_modal_overlay_class: '', 
                            bs_dialog_container_class: '', 
                            bs_content_container_class: '', 
                            bs_content_header_class: '', 
                            bs_content_title_class: '', 
                            bs_content_body_class: '', 
                            bs_content_footer_class: ''
                        } : { 
                            bs_modal_overlay_class: check_data_val(this.data.targets.custom_classes.sections.bs_modal_overlay_class), 
                            bs_dialog_container_class: check_data_val(this.data.targets.custom_classes.sections.b_dialog_container_class), 
                            bs_content_container_class: check_data_val(this.data.targets.custom_classes.sections.bs_content_container_class), 
                            bs_content_header_class: check_data_val(this.data.targets.custom_classes.sections.bs_content_header_class), 
                            bs_content_title_class: check_data_val(this.data.targets.custom_classes.sections.bs_content_title_class), 
                            bs_content_body_class: check_data_val(this.data.targets.custom_classes.sections.bs_content_body_class), 
                            bs_content_footer_class: check_data_val(this.data.targets.custom_classes.sections.bs_content_footer_class)
                        }
                    }
                }
            }
    
            this.targets = modalTargets;

            if(this.debug.targets)
                console.log(this.targets, "targets");
        }catch(e){
            console.log(e);
            console.log(this.targets, "targets");
        }

    }

    modalHeader(){
        try{
            if(this.extract){
                var dataset = this.data.target.dataset;
                var header = { 
                    title: check_data_val(dataset.bsHeaderTitle), 
                    navigation: { 
                        custom_html: ( dataset.bsHeaderNavigationCustomHtml) && (check_data_val(dataset.bsHeaderNavigationCustomHtml).length > 0) ? get_custom_html_link(dataset.bsHeaderNavigationCustomHtml) : ''
                    }, 
                    custom_close_icon: check_data_val(dataset.bsHeaderNavigationCustomCloseIcon) 
                }
            }else{
                var header = { 
                    title: check_data_val(this.data.header.title),
                    navigation: { 
                        custom_html: check_data_val(this.data.header.navigation.custom_html)
                    },
                    custom_close_icon: check_data_val(this.data.header.navigation_custom_close_icon) 
                }
            }
            
            this.header = header;

            if(this.debug.header)
                console.log(this.header, "header");
        }catch(e){
            console.log(e);
            console.log(this.header, "header");
        }
    }

    modalContent(){
        try{
            if(this.extract){
                var dataset = this.data.target.dataset;
                if(dataset.bsContentTplFile){
                    var content = { 
                        tpl_file: check_data_val(dataset.bsContentTplFile)
                    }
                }else{
                    var content = { 
                        main: check_data_val(dataset.bsContentMain)
                    }
                }
            }else{
                if(this.data.content.tpl_file){
                    var content = { 
                        tpl_file: check_data_val(this.data.content.tpl_file)
                    }
                }else{
                    var content = { 
                        main: check_data_val(this.data.content.main)
                    }
                }

            }
    
            this.content = content;

            if(this.debug.content)
                console.log(this.content, "content");
        }catch(e){
            console.log(e);
            console.log(this.content, "content");
        }
    }

    modalButtons(){
        try{
            if(this.extract){
                var dataset = this.data.target.dataset;
                var buttons = { 
                    defualt: dataset.bsFooterDefault == 'hide' ? false : check_bool(dataset.bsFooterDefault), 
                    custom_btns: dataset.bsFooterCustomBtns ? this.get_custom_buttons_data() : false,
                    auto_callback: (dataset.bsButtonsAutoCallback && dataset.bsButtonsAutoCallback.length > 0) ? dataset.bsButtonsAutoCallback : false
                }
            }else{
                var buttons = { 
                    defualt: this.data.buttons.default == 'hide' || this.data.buttons.custom_btns ? false : this.data.buttons.default,
                    custom_btns: this.data.buttons.btns ? this.get_custom_buttons_data() : false,
                    auto_callback: check_data_val(this.data.buttons.auto_cb)
                }
            }
    
            this.buttons = buttons;

            if(this.debug.buttons)
                console.log(this.buttons, "buttons");
        }catch(e){
            console.log(e);
            console.log(this.buttons, "buttons");
        }
    }

    modalEtc(){
        try{
            if(this.extract){
                var dataset = this.data.target.dataset;
                var etc = {
                    size: check_size(dataset.bsSize),
                    hidden: check_bool(dataset.bsHidden),
                    closeOnSuccess: dataset.bsCloseOnSuccess,
                    confirmCloseModal: dataset.bsConfirmClosemodal
                }
            }else{
                var etc = {
                    size: check_size(this.data.size),
                    hidden: check_bool(this.data.hidden),
                    closeOnSuccess: this.data.closeOnSuccess,
                    confirmCloseModal: this.data.confirmClosemodal
                }
            }
    
            this.etc = etc
            if(this.debug.etc)
                console.log(this.etc, "this.etc");
        }catch(e){
            console.log(e);
        }
    }

    confirmModal(){
        if(!this.data.confirmCloseModal)
            return false;

        try{
            if(this.data.confirmCloseModal.default){
                var msg = this.extract ? ( this.data.dataset.bsConfirmCloseModal ? this.data.dataset.bsConfirmCloseModal : get_language_translation('LANG_MSG_LEAVING_THIS_PAGE_MAY_RESULT_IN_UNSAVED_CHANGES') ) : ( this.data.confirmCloseModal.msg ? this.data.confirmCloseModal.msg : get_language_translation('LANG_MSG_LEAVING_THIS_PAGE_MAY_RESULT_IN_UNSAVED_CHANGES') )
                var conf_modal = {
                    default: false,
                    id: 'confirm_close_modal',
                    toggle_to_id: this.targets.modalid,
                    targets: {
                        content: { custom_id: 'default-confirm-close-modal-content', custom_class: 'default-confirm-close-content', custom_data: false },
                        header: { custom_id: 'default-confirm-close-modal-header', custom_class: 'default-confirm-close-header', custom_data: false },
                        body: { custom_id: 'default-confirm-close-modal-body', custom_class: 'default-confirm-close-body', custom_data: false },
                        footer:{ custom_id: 'default-confirm-close-modal-footer', custom_class: 'default-confirm-close-footer', custom_data: false } 
                    },
                    content: {
                        header: { title: { msg: '' }, close: { visible: true } },
                        body: { msg: msg },
                        footer: [ 
                            { outline: true, color: 'red', btn: 'Leave', cb: `kill_modals()` }, 
                            { outline: false, color: 'blue', btn: 'Stay', cb: `get_original_modal('${this.targets.modalid}', 'confirm_close_modal')` } 
                        ]
                    }
                }
            }else{
                if(this.extract){
                    // No current use for this will build if needed
                    var conf_modal = false;
                }else{
                    var conf_modal = {
                        default: false,
                        id: 'confirm_close_modal',
                        toggle_to_id: 'progress_modal',
                        targets: false,
                        content: {
                            header: { title: { msg: '' }, close: { visible: true } },
                            body: { msg: get_language_translation('LANG_MSG_LEAVING_THIS_PAGE_MAY_RESULT_IN_UNSAVED_CHANGES') },
                            footer: { 
                                btn1: { outline: true, color: 'red', msg: 'Leave' }, 
                                btn2: { color: 'blue', msg: 'Stay', cb: false } 
                            } 
                        }
                    }
                }
            }
            
    
            this.confirmCloseModal = conf_modal
            if(this.debug.conf_modal)
                console.log(this.confirmCloseModal, "this.confirmCloseModal");
        }catch(e){
            console.log(e);
        }
    }

    onBuild(){
        if(!this.data.onBuild)
            return false;

        try{
            if(this.extract){
                // No current use for this will build if needed
                var onBuild = false;
            }else{
                var onBuild =  this.data.onBuild;
            }
    
            this.onBuildCb = onBuild
            if(this.debug.onBuild)
                console.log(this.onBuildCb, "this.onBuildCb");
        }catch(e){
            console.log(e);
        }
    }

    addModal(){
        if(!this.data.add_togglable_modal)
            return false;

        try{
            if(this.extract){
                // No current use for this will build if needed
                var add_modal = false;
            }else{
                var add_modal =  this.data.add_togglable_modal;
            }

            this.add_togglable_modal = add_modal
            if(this.debug.add_togglable_modal)
                console.log(this.add_togglable_modal, "this.add_togglable_modal");
        }catch(e){
            console.log(e);
        }
    }

    build_confirm_modal(){
        var btns = this.build_footer(true);
        var conf_modal = `<div class="modal fade" id="${this.confirmCloseModal.id}" aria-hidden="true" aria-labelledby="${this.confirmCloseModal.id}" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div id="${this.confirmCloseModal.targets.content.custom_id}" class="modal-content ${this.confirmCloseModal.targets.content.custom_class ? this.confirmCloseModal.targets.content.custom_class : ''}" ${this.confirmCloseModal.targets.content.custom_data ? this.confirmCloseModal.targets.content.custom_data : ''}>
                    <div id="${this.confirmCloseModal.targets.header.custom_id}" class="modal-header ${this.confirmCloseModal.targets.header.custom_id}" ${this.confirmCloseModal.targets.header.custom_data ? this.confirmCloseModal.targets.header.custom_data : ''}> 
                        ${this.confirmCloseModal.content.header.title.msg}
                    </div>
                    <div id="${this.confirmCloseModal.targets.body.custom_id}" class="modal-body ${this.confirmCloseModal.targets.body.custom_class}" ${this.confirmCloseModal.targets.body.custom_data ? this.confirmCloseModal.targets.body.custom_data : ''}>
                        <h6 class="am-modal-icon center"><i class="fas fa-exclamation-triangle"></i></h6>
                        <span class="am-modal-text-default">${this.confirmCloseModal.content.body.msg}</span>
                    </div>
                    ${btns}
                </div>
            </div>
        </div>`;

        return conf_modal;
    }

    get_custom_buttons_data(){
        try{
            var btn_obj = {};
            if(this.extract){ // this process is limited for data-attr process - try using object based build for further complexity
                var dataset = this.data.target.dataset
                var count = parseInt(dataset.bsFooterCustomBtnsCount);
                if(count === 2){
                    btn_obj = { 
                        custom_btns: true, count: 2, custom_modal_btns_class: 'am-custom-btns--modal',
                        btns: [ 
                            { outline: dataset.bsFooterDefaultConfirmTypeBtnOutline0, color: dataset.bsFooterDefaultConfirmTypeBtnColor0, btn: dataset.bsFooterDefaultConfirmTypeBtn0, cb: dataset.bsFooterDefaultConfirmTypeCb0, disabled: dataset.bsFooterDefaultConfirmTypeDisabled0, id: dataset.bsFooterDefaultConfirmTypeId0},
                            { outline: dataset.bsFooterDefaultConfirmTypeBtnOutline1, color: dataset.bsFooterDefaultConfirmTypeBtnColor1, btn: dataset.bsFooterDefaultConfirmTypeBtn1, cb: dataset.bsFooterDefaultConfirmTypeCb1, disabled: dataset.bsFooterDefaultConfirmTypeDisabled1, id: dataset.bsFooterDefaultConfirmTypeId1}, 
                        ],
                    }
                }else if(count === 1){
                    btn_obj = { 
                        custom_btns: true, count: 1, custom_modal_btns_class: 'am-custom-btns--modal',
                        btns: [ 
                            { outline: dataset.bsFooterDefaultConfirmTypeBtnOutline0, color: dataset.bsFooterDefaultConfirmTypeBtnColor0, btn: dataset.bsFooterDefaultConfirmTypeBtn0, cb: dataset.bsFooterDefaultConfirmTypeCb0, disabled: dataset.bsFooterDefaultConfirmTypeDisabled0, id: dataset.bsFooterDefaultConfirmTypeId0}
                        ],
                    }
                }else{
                    alert('This will not work either add a new case or use object based process for more complexity');
                }
            }else{
                var btns = [];
                this.data.buttons.btns.each((btn) => {
                    var formatted_btn = {
                        outline: check_data_val(btn.outline), color: check_data_val(btn.color), btn: check_data_val(btn.btn), cb: check_data_val(btn.cb), disabled: check_data_val(btn.disabled), id: check_data_val(btn.id)
                    }
                    btns.push(formatted_btn);
                })

                btn_obj = { 
                    custom_btns: this.data.buttons.custom_btns, 
                    count: this.data.buttons.count, 
                    custom_modal_btns_class: this.data.buttons.custom_modal_btns_class,
                    btns: btns
                }
            }

            return btn_obj;
        }catch(e){
            console.log(e);
        }
    }

    build_footer(confirm_modal=false){
        if(!confirm_modal){
            var def = this.buttons.defualt;
            var custom_btns = this.buttons.custom_btns
        }else{
            var def = this.confirmCloseModal.default
            var custom_btns = this.confirmCloseModal.content.footer
        }

        if(!def && !custom_btns){
            return '';
        }
        else if(custom_btns){
            var btns = this.get_custom_footer_btns_by_obj(confirm_modal); 
        }
        else if(def){
            var btns = `<button type="button" class="am-btn am-btn--filled" data-bs-dismiss="modal">
                            <span> ${get_language_translation('LANG_CLOSE')} </span>
                        </button>`;
        }

        if(!confirm_modal){  
            return `<div id="${this.targets.modalid}-footer" class="modal-footer ${this.targets.custom_classes.sections.bs_content_footer_class}">${btns}</div>`;
        }else{
            return `<div id="${this.confirmCloseModal.id}-footer" class="modal-footer ${this.confirmCloseModal.targets.footer.custom_class}">${btns}</div>`;
        }
    }

    get_custom_footer_btns_by_obj(confirm_modal){
        try{
            var obj = !confirm_modal ? this.buttons.custom_btns.btns : this.confirmCloseModal.content.footer;
            var btns = ``;

            Object.entries(obj).forEach(([key, value]) => {
                var btn_outline = value.outline;
                var btn_color = value.color;
                var btn_disabled = value.disabled ? 'disabled="disbaled"' : '';
                var dismiss = value.cb == 'data-bs-dismiss' ? 'data-bs-dismiss="modal"' : '';

                if(btn_outline){
                    btns += `<button ${value.id ? `id="${value.id}"` : ''} type="button" class="am-btn am-btn--outlined ${value.color === 'red' ? 'am-btn--danger' : ''}" 
                                ${dismiss} onclick="${value.cb}" ${btn_disabled} >
                                ${value.btn}
                            </button>`
                }else if(btn_color){
                    btns += `<button ${value.id ? `id="${value.id}"` : ''} type="button" class="am-btn am-btn--filled ${value.color === 'red' ? 'am-btn--danger' : ''}" 
                                ${dismiss} onclick="${value.cb}" ${btn_disabled} >
                                ${value.btn}
                            </button>`
                }
                else{
                    btns += `<button ${value.id ? `id="${value.id}"` : ''} type="button" class="am-btn am-btn--filled" ${dismiss} 
                                onclick="${value.cb}" ${btn_disabled} >
                                ${value.btn}
                           </button>`
                }
            })
       
            return `<div class="am-custom-modal-btns-wrapper ${this.buttons.custom_btns.custom_modal_btns_class}"> ${btns} </div>`;
        }catch(e){
            console.log(e);
        }
    }
}

function get_original_modal(modal, conf_modal){
    var modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(modal));
    var conf_modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(conf_modal));
    conf_modal.hide();
    modal.show();
}

function kill_all_modal_elements(overflow=false){
    kill_modals();
    kill_backdrop();

    if(overflow)
        am.$('body').css('overflow', 'unset');
}

function kill_modals(){
    var children = am.$('#bs-modal-wrapper').children();
    if(children.length > 0){
        children.each((i, el)  => {
            el.remove();
        })
    }
}

function kill_backdrop(){
    am.$('.modal-backdrop').remove();
}

function check_data_val(val, req_loc=false){ 
    // check value and replace with '' if false 
    // if req_loc is true it will tell where a value is required 
    try{
        if( !val || val === 'false' || val === undefined )
            val = false;

        if( req_loc){
            if(!val || val == '' )
                console.log(req_loc + ' is a required value for modal and is missing');
            else
                return !val ? '' : val;
        }
        else{
            return !val ? '' : val;
        }
    }catch(e){
        console.log(e)
    }
    
}

function check_bool(val){
    return !val ? true : val;
}

function check_size(val){
    var size = (val == 'modal-xl' || val == 'modal-lg' || val == 'modal-md' || val == 'modal-sm') ? true : false;
    if(!size)
        val = 'modal-md';

    return val;
}

function get_custom_html_link(type){
    switch(type) {
        case 'header_content':
            return  '<a href="help/settings/header/#header_content" onclick="return open_in_new_tab(this);"><i class="fas fa-external-link-alt"></i></a>';
        default:
            return '';
    }
}

function build_confirm_content(msg, quote_break = "'", icon='fa fa-trash'){ // icon='hide' will act as a simple confirm without icon header
    hide = icon == 'hide' ? `style=${quote_break}display: none;${quote_break}` : '';
    var content = `<h6 ${hide} class=${quote_break}am-modal-icon center${quote_break}>
        <i class=${quote_break}${icon}${quote_break}></i>
    </h6>
    <div class=${quote_break}am-confirm-msg${quote_break}>
        ${msg}
    </div>
    `;
    return content;
}

function build_progress_content(header, sub_context, quote_break = "'"){
    var content = `<h6 class=${quote_break}am-modal-icon center${quote_break}>
            <i class=${quote_break}fa-solid fa-arrows-rotate fa-spin ${quote_break}></i>
        </h6>
        <div class=${quote_break}am-progress-msg${quote_break}>
            <span class="prog-header">${header}</span>
            <span class="prog-subcontent">${sub_context}</span>
        </div>
    `;
    return content;
}

function duplicate_modal_backdrop_check(){
    var backdrops = am.$('.modal-backdrop');
    if(backdrops.length >= 1){
        backdrops.each((i, el) => {
            if(i != 0)
                am.$(el).removeClass('show').remove();
        })
    }
}

function build_acknowledge_content(main_msg, agree_msg, quote_break = "'", icon='fa-solid fa-triangle-exclamation'){
    icon = ' ' + icon + ' '; // leave this to avoid issues with template_literal / minifier
    var content = `<h6 class=${quote_break}am-modal-icon center${quote_break}>
            <i class=${quote_break} ${icon} ${quote_break}></i>
        </h6>
        <div class=${quote_break}acknowledge-content${quote_break}> 
            <span class=${quote_break}main-acknowledge-msg${quote_break}>${main_msg}</span>
            <div class=${quote_break}ackknowledge${quote_break}>
                <input id=${quote_break}modal_ackknowledge_cb${quote_break} class=${quote_break}am-customCheckbox${quote_break} type=${quote_break}checkbox${quote_break} onclick=${quote_break}confirm_modal_msg(this)${quote_break} /> 
                <label for=${quote_break}modal_ackknowledge_cb${quote_break} class=${quote_break}agreement-msg${quote_break}>${agree_msg}</label> 
            </div>
        </div>
    `;
    return content;
}

function confirm_modal_msg(t){
	const $this = am.$(t);
	if($this.prop('checked'))
		am.$('#modal_msg_confirmed').prop('disabled', false)
	else
		am.$('#modal_msg_confirmed').prop('disabled', true)
}

function build_error_content(msg, quote_break = "'"){
    var content = `<h6 class=${quote_break}am-modal-icon center${quote_break}>
        <i class=${quote_break}fa-solid fa-triangle-exclamation${quote_break}></i>
    </h6>
    <div class=${quote_break}am-error-msg${quote_break}>
        ${msg}
    </div>
    `;
    return content;
}